import type { AvailableSlotItem, AvailableSlotsResponse } from "./types/appointment.types"

export function resolveAvailableSlots(response: AvailableSlotsResponse | null | undefined): AvailableSlotItem[] {
  return Array.isArray(response?.slots) ? response.slots : []
}
